<template>
  <van-popup v-model="show" style="border-radius: 4px;">
    <div class="popup-content">
      <div class="title">请联系客服</div>
      <div class="content">
        <div>
          <p>
            <van-icon name="phone" size="14px" /> 致电：
            <a id="tel" :href="`tel:${service.mobile}`" class="phone">{{ service.mobile }}</a>
          </p>
          <p>或</p>
          <p>扫码添加客服微信</p>
          <img :src="service.wxQrcode" :width="160" :height="160" alt="客服二维码">
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'CustomerServiceDialog',
  props: {
    service: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.close {
  position: absolute;
  right: 10px;
  top: -30px;
  color: rgba($color: #FFFFFF, $alpha: .3);
}
.popup-content {
  position: relative;
  width: 260px;
  padding: 30px 0;
  text-align: center;
  .title {
    @include ft(22px, 30px);
    color: #000;
    margin-bottom: 18px;
  }
  p {
    color: $color-text-heavy;
    @include ft(16px, 22px);
    margin-bottom: 6px;
  }
  .phone {
    color: #E1AB74;
    font-weight: 500;
  }
}
</style>
